import type { FC, PropsWithChildren } from 'react';
import { createContext, useRef } from 'react';
import type { StoreApi } from 'zustand';

import { createInsightsStoreWithInitial } from './InsightsStore';
import type { InsightsStore, InsightStoreInitialValues } from './InsightsStore.types';

type InsightsContextStore = StoreApi<InsightsStore> | undefined;
type InsightsStoreProviderProps = PropsWithChildren<{ initialValues: InsightStoreInitialValues }>;

export const InsightsContext = createContext<InsightsContextStore>(undefined);

export const InsightsStoreProvider: FC<InsightsStoreProviderProps> = ({ children, initialValues }) => {
	if (!initialValues) {
		throw new Error('Missing initial values for InsightsStore');
	}

	const insightsStoreRef = useRef<InsightsContextStore>();

	const setupStore = () => {
		insightsStoreRef.current = createInsightsStoreWithInitial(initialValues);
	};

	if (!insightsStoreRef.current) {
		setupStore();
	}

	return <InsightsContext.Provider value={insightsStoreRef.current}>{children}</InsightsContext.Provider>;
};
